﻿import { defineComponent, inject, onMounted, ref } from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "HeaderLink",

    props: {
        webSite: {
            type: String,
            required: true,
        },
    },
    components: {},
    setup() {
        return {};
    },
    template: html`
        <div class="header-link" v-if="webSite!='bbc' && webSite!='b2e'">
            <ul class="link-list taiwan" v-if="webSite=='b2c'">
                <li alt="台灣旅遊" id="domestic" class="link-list-item">
                    <a
                        href="/Destination/19"
                        alt="台灣旅遊"
                        rel="noopener noreferrer"
                    >
                        台灣旅遊
                    </a>
                </li>
            </ul>
            <ul class="link-list direct">
                <li
                    alt="自組一團"
                    id="self_group"
                    class="link-list-item"
                    v-if="webSite=='b2c'"
                >
                    <a
                        href="/contact/selfgroup"
                        alt="自組一團"
                        rel="noopener noreferrer"
                    >
                        自組一團
                    </a>
                </li>
                <li
                    alt="企業專區"
                    id="company"
                    class="link-list-item"
                    v-if="webSite=='b2c'"
                >
                    <a
                        href="//b2e.bwt.com.tw/"
                        target="_blank"
                        alt="企業專區"
                        rel="noopener noreferrer"
                    >
                        企業專區
                    </a>
                </li>
                <li
                    alt="同業網"
                    id="b2b_class"
                    class="link-list-item"
                    v-if="webSite=='b2c'"
                >
                    <a
                        href="//b2b.bwt.com.tw/"
                        target="_blank"
                        alt="同業網"
                        rel="noopener noreferrer"
                    >
                        同業網
                    </a>
                </li>
                <li
                    alt="同業部通訊錄"
                    id="same_class_book"
                    class="link-list-item"
                    v-if="webSite=='b2b'"
                >
                    <a
                        href="/Contract/C"
                        target="_blank"
                        alt="同業部通訊錄"
                        rel="noopener noreferrer"
                    >
                        同業部通訊錄
                    </a>
                </li>
                <li
                    alt="直客網"
                    id="b2c_class"
                    class="link-list-item"
                    v-if="webSite=='b2b'"
                >
                    <a
                        href="//www.bwt.com.tw"
                        alt="直客網"
                        rel="noopener noreferrer"
                    >
                        直客網
                    </a>
                </li>
                <!--<li alt="佈告欄" class="link-list-item bulletin" style="">
                    <a href="/B2E/BBS" alt="佈告欄">佈告欄</a>
                </li>
                <li
                    alt="熱門推薦"
                    class="link-list-item hot"
                    id="b2e_urgent"
                    style=""
                >
                    <a alt="熱門推薦" style="cursor:pointer">熱門推薦</a>
                </li>
                <li alt="補助規定" class="link-list-item allowance" style="">
                    <a alt="補助規定">補助規定</a>
                    <ul class="link-list-drop">
                        <li id="Subsidy1" style="">
                            <a href="/B2E/Process">報名流程</a>
                        </li>
                        <li id="Subsidy2" style="">
                            <a href="/B2E/Cancel">旅遊取消規定</a>
                        </li>
                        <li id="Subsidy3" style="display:none;">
                            <a href="/B2E/Subsidy">申請補助流程</a>
                        </li>
                    </ul>
                </li>-->
            </ul>
        </div>
    `,
});
